<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<!-- eslint-disable max-len -->
<template>
  <div class="main">

    <div class="row">

      <div class="column">
        <h1>Gym Buddy</h1>

        <h2>Your helper in the gym. Fully custom workouts for free.</h2>

        <!-- <h2 style="color: grey; margin-top: 5px;">Coming soon to an App Store near you.</h2> -->

        <img @click="openInNewTab('https://apps.apple.com/it/app/gym-buddy-tracker/id1659216618?l=en')" class="app-store" src="../assets/app-store-black.svg" alt="Download on the App Store">

      </div>

      <div class="screen-container">
        <img class="screen" src="../assets/screen.png" alt="Screenshot">
      </div>

    </div>

  </div>
</template>

<script>

export default {
  name: 'HomePage',
  components: {
  },
  methods: {
    openInNewTab(url) {
      window.open(url, '_blank', 'noreferrer');
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Black+Ops+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200');

html, body, #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: #000000;
  margin-top: 60px;
}

.main {
  background-color: #000000;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;

  .row {
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
  }

  .column {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    margin-right: 200px;
  }

  .screen-container {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .screen {
      height: 90vh;
    }
  }

  .app-store {
    cursor: pointer;
    margin-top: 10px;
  }
}

h1 {
  color: white;
  font-size: 70px;
  line-height: 70px;
  font-family: 'Black Ops One', cursive;
  padding: 0;
  margin: 0px;
}

h2 {
  color: #69F0AEFF;
  font-size: 16px;
}

@media screen and (max-width: 1200px) {
  .row {
    flex-direction: column !important;
  }

  .column {
    align-items: center !important;
    margin-right: 0 !important;
    margin-bottom: 50px;
  }

  .screen {
    height: 50vh !important;
  }

  h1 {
    font-size: 40px;
  }

}

</style>
